var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcLightbulb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 29.25H21M16 33H20",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1159 20.5207L12.7719 22.0795C13.2366 22.5168 13.5 23.1265 13.5 23.7645C13.5 24.723 14.277 25.5 15.2355 25.5H20.7645C21.723 25.5 22.5 24.723 22.5 23.7645C22.5 23.1265 22.7634 22.5168 23.2281 22.0795L24.8841 20.5207C27.1959 18.3281 28.4869 15.4476 28.4999 12.4529L28.5 12.3271C28.5 7.21035 23.799 3 18 3C12.201 3 7.5 7.21035 7.5 12.3271L7.5001 12.4529C7.51313 15.4476 8.80409 18.3281 11.1159 20.5207Z",
    stroke: "currentColor",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLightbulb);
export default __webpack_public_path__ + "static/media/ic_lightbulb.3183ea80a507d4217aeef662cd86dc26.svg";
export { ForwardRef as ReactComponent };